import { WSCard, WSGrid, WSInfoBox } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD } from "../../Settings/routes/RoutePaymentMethods";

export const EmptyState = () => {
  const history = useHistory();

  return (
    <WSGrid>
      <WSGrid.Item span={{ l: "8" }}>
        <WSCard
          divider
          actions={{
            alignment: "fill",
            buttons: [
              {
                kind: "Secondary",
                label: "Get started",
                onClick: () => {
                  history.push(
                    PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD +
                      "/platform-balance"
                  );
                }
              }
            ]
          }}
        >
          <WSInfoBox transparent>
            <p>
              You have the option to use a Platform Balance to hold your
              earnings securely in a preferred currency of your choice until you
              are ready to transfer it out to the bank account you’ve added.
              This is a benefit available to you for free with the Wingspan
              platform.
            </p>
            <p>
              <b>Why is this offered?</b> Some non-U.S. contractors prefer to
              keep their earnings on the platform in a preferred currency until
              they are ready to transfer the balance to their external bank
              account for various reasons (such as exchange rates and
              inflation). Additionally, in the event that a payout to the
              external bank account fails repeatedly, the earnings will be held
              in the Platform Balance - allowing contractors to transfer it out
              once any issues are resolved.
            </p>
          </WSInfoBox>
        </WSCard>
      </WSGrid.Item>
    </WSGrid>
  );
};
